"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PalladinShipping = void 0;
const Resources_1 = require("../../Resources");
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const Size_1 = require("../render/Size");
const Units_1 = require("../../Units");
const constants_1 = require("../../constants");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
class PalladinShipping extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.PALLADIN_SHIPPING,
            tags: [Tags_1.Tags.SPACE],
            startingMegaCredits: 36,
            metadata: {
                cardNumber: '??',
                description: 'You start with 36 M€. Gain 5 titanium.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(36).titanium(5).digit;
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect('When you play a Space Event, gain 1 titanium.', (eb) => {
                            eb.space().played.event().played.nbsp(Size_1.Size.TINY).startEffect.titanium(1);
                        });
                        ce.action('Spend 2 titanium to raise temperature 1 step.', (eb) => {
                            eb.titanium(2).startAction.temperature(1);
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                    });
                }),
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.TITANIUM, 5);
        return undefined;
    }
    canAct(player) {
        if (player.titanium < 2)
            return false;
        const temperatureMaxed = player.game.getTemperature() === constants_1.MAX_TEMPERATURE;
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        const trGain = this.getTotalTRGain(player);
        Card_1.Card.setRedsActionWarningText(player, trGain, this, redsAreRuling, 'raise temperature');
        if (temperatureMaxed) {
            Card_1.Card.setUselessActionWarningText(this, 'temperature is already maxed');
            return true;
        }
        if (redsAreRuling) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails();
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        return true;
    }
    action(player) {
        player.deductResource(Resources_1.Resources.TITANIUM, 2);
        player.game.increaseTemperature(player, 1);
        return undefined;
    }
    onCardPlayed(player, card) {
        const corpOwner = player.game.getCardPlayer(this.name);
        if (card.cardType === CardType_1.CardType.EVENT && card.tags.includes(Tags_1.Tags.SPACE) && player.id === corpOwner.id) {
            corpOwner.addResource(Resources_1.Resources.TITANIUM, 1, { log: true });
        }
    }
    getTotalTRGain(player) {
        const temperature = player.game.getTemperature();
        let trGain = temperature === constants_1.MAX_TEMPERATURE ? 0 : 1;
        if (temperature === -2)
            trGain += 1;
        return trGain;
    }
    getActionDetails() {
        return new RedsPolicy_1.ActionDetails({ temperatureIncrease: 1 });
    }
}
exports.PalladinShipping = PalladinShipping;
//# sourceMappingURL=PalladinShipping.js.map